export default {"src":"/_next/static/media/tik-tok-profile-image.6bffff6a.svg","height":220,"width":138,"blurWidth":0,"blurHeight":0};